var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeIcMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #437063;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 14px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 60.8,
    y1: 119.81,
    x2: 152.27,
    y2: 119.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 60.8,
    y1: 154.83,
    x2: 146.24,
    y2: 154.83
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M183.54,86.85c-10.94-8.63-24.74-13.79-39.75-13.79-35.49,0-64.26,28.77-64.26,64.26s28.77,64.26,64.26,64.26c15.01,0,28.81-5.16,39.75-13.79"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 260,
    height: 260
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeIcMoney);
export default __webpack_public_path__ + "static/media/HE-IC-Money.2e81c7c8c5db854761d258b065262f71.svg";
export { ForwardRef as ReactComponent };